<template>
  <section class="wealth">
    <!-- <div class="wealth-banner">
      <div class="wealth-price">{{ wealthData.balance }}</div>
      <div class="wealth-today">今日红包收入：￥{{ wealthData.todayTotalIncome }}</div>
      <div class="wealth-tab">
        <div @click="handleNavigate('/wealth/detail')">红包明细</div>
        <div @click="handleNavigate('/wealth/rule')">领取规则</div>
      </div>
    </div> -->
    <div class="wealth-section">
      <div class="wealth-section-price"
        data-title="余额">{{ wealthData.balance }}<span>元</span>
        <div class="wealth-section-price-button with-border"
          @click="handleNavigate('/wealth/detail')">明细</div>
      </div>
      <!-- <div class="wealth-section-price"
        data-title="可提现">{{ wealthData.todayTotalIncome }}<span>元</span>
        <div class="wealth-section-price-button">提现</div>
      </div>
      <div class="wealth-section-rule"
        @click="handleNavigate('/wealth/rule')">查看提现规则</div> -->
    </div>
    <!-- <div class="wealth-task">
      <div class="wealth-task-title">邀请任务</div>
      <ul class="wealth-task-list">
        <li v-for="course in courseList"
          :key="course.id"
          :data-earning="course.price"
          @click="handleShare(course)">
          <div>
            <img :src="course.courseImage">
          </div>
          <div class="wealth-task-info">
            <div class="wealth-task-info-title">{{ course.courseName }}</div>
            <div class="wealth-task-info-text">
              <span>{{ course.count }}</span>名好友感兴趣，得<span>{{ course.price }}</span>元红包
            </div>
          </div>
        </li>
      </ul>
    </div> -->
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Wealth',
  computed: mapState({
    wealthData: state => state.wealth.wealthData,
    courseList: state => state.wealth.courseList
  }),
  created () {
    // console.log( this['wealth/getWealthData'])
    this['wealth/getWealthData']()
    this['wealth/getCourseList']({})
  },
  methods: {
    ...mapActions([
      'wealth/getWealthData',
      'wealth/getCourseList',
      'wealth/share'
    ]),
    handleNavigate (url) {
      if (typeof url === 'string') {
        this.$router.push(url)
      } else {
        const { path, name } = url
        this.$router.push({
          path, name
        })
      }
    },
    handleShare (course) {
      const { id, type } = course
      this['wealth/share']({ id, type })
    }
  }
}
</script>

<style lang="scss">
  @charset 'utf-8';
  @import '../style/main';

  $global-width: 750;

  .wealth {
    overflow-y: scroll;
    height: 100%;
    font-family: PingFangSC-Regular;

    &-section {
      margin: 0 rem(30) rem(30);
      padding: 0 rem(30);
      background-color: #fff;
      border-radius: 8px;

      &-price {
        position: relative;
        padding: rem(40) 0;
        font-size: rem(48);
        color: #555;

        & > span {
          vertical-align: middle;
          font-size: rem(24);
        }

        &::before {
          content: attr(data-title);
          display: block;
          margin-bottom: rem(12);
          font-size: rem(26);
          color: #999;
        }

        &-button {
          $color: #f48e01;

          box-sizing: border-box;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          right: 0;
          width: rem(180);
          height: rem(60);
          line-height: rem(60);
          border-radius: 3px;
          background-color: $color;
          text-align: center;
          font-size: rem(24);
          color: #fff;

          &.with-border {
            border: 1px solid $color;
            background-color: #fff;
            color: $color;
          }
        }
      }

      &-rule {
        font-size: rem(24);
        color: #999;

        &::before {
          $size: rem(23);

          content: '';
          display: inline-block;
          vertical-align: middle;
          margin-right: rem(10);
          width: $size;
          height: $size;
          background-image: url('../assets/images/wealth-icon-tip.png');
          background-size: 100% 100%;
        }
      }
    }

    &-banner {
      overflow: hidden;
      position: relative;
      height: rem(420);
      background-image: url('../assets/images/wealth-bg.png');
      background-size: contain;
      text-align: center;
      color: #fff;

      &::before {
        content: '— 红包总金额 —';
        display: block;
        margin-top: rem(60);
        font-size: rem(26);
      }
    }

    &-price {
      margin: rem(40) 0 rem(20);
      font-weight: bold;
      font-size: rem(90);

      &::before {
        content: '￥';
        font-size: rem(50);
      }
    }

    &-today {
      font-size: rem(26);
    }

    &-tab {
      position: absolute;
      bottom: 0;
      left: 0;
      display: table;
      padding: rem(30) 0;
      width: 100%;
      font-weight: 600;
      font-size: rem(30);

      & > div {
        display: table-cell;
        position: relative;

        &:not(:first-child) {
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 1px;
            height: 100%;
            background-color: #fff;
          }
        }
      }
    }

    /** banner end **/

    &-task {
      margin: 0 rem(30);
      padding: rem(40) rem(30);
      border-radius: 8px;
      background-color: #fff;

      &-title {
        font-weight: bold;
        font-size: rem(30);
        color: #444;

        &::after {
          content: '邀请好友参加课程，多邀多得';
          display: inline-block;
          margin-left: rem(20);
          padding-left: rem(20);
          border-left: 1px solid #bfbfbf;
          font-size: rem(24);
          color: #bfbfbf;
        }
      }

      &-list {
        & > li {
          position: relative;
          padding: rem(30) 0;

          // 边框
          &::before {
            content: '';
            transform: scaleY(.5);
            transform-origin: 0 1px;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 1px;
            background-color: #e4e4e4;
          }

          // 按钮
          &::after {
            content: '赚￥'attr(data-earning);
            transform: translateY(-50%);
            position: absolute;
            top: 50%;
            right: 0;
            padding: rem(6) rem(20);
            border-radius: 3px;
            background-color: #f48e01;
            font-weight: 600;
            font-size: rem(24);
            color: #fff;
          }

          & img {
            display: block;
            width: 100%;
          }

          & > div {
            display: inline-block;
            vertical-align: middle;
            max-width: rem(320);
            line-height: 1.5;

            &:first-child {
              overflow: hidden;
              width: rem(194);
              border-radius: 3px;
            }
          }
        }
      }

      &-info {
        margin-left: rem(30);

        &-title {
          font-size: rem(28);
          color: #333;
        }

        &-text {
          max-width: rem(250);
          font-size: rem(22);
          color: #999;

          & > span {
            color: #ff5b34;
          }
        }
      }
    }

    /** task end **/
  }

  $global-width: 720;
</style>
